import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

//查询待发货计划

export const getStockingPlanRelationByOrgID = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetStockingPlanRelationByOrgID`, { params: params });
};

export const getTFDeliveryOrderByOrgID = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetTFDeliveryOrderByOrgID`, { params: params });
};

//选择装车计划
export const getStockingBoxSumByStockingTaskID = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetStockingBoxSumByStockingTaskID`, { params: params });
};
//查询发货计划箱明细
export const GetStockingBoxListByStockingTaskID = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetStockingBoxListByStockingTaskID`, { params: params });
};

//添加装车单
export const addLoadCarInfo = params => {
    return axios.post(`${BaseApiUrl}/LoadCarInfo/addLoadCarInfo`, params);
};

//查询装车单详情
export const getLoadCarInfoByLoadCarInfoID = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetLoadCarInfoByLoadCarInfoID`, { params: params });
};

//查询装车单列表
export const getLoadCarInfoAsync = params => {
    return axios.post(`${BaseApiUrl}/LoadCarInfo/GetLoadCarInfoAsync`, params);
};


//导出装车单
export const exportLoadCarInfoAsyncOut = `${BaseApiUrl}/LoadCarInfo/LoadCarInfoAsyncOut`;


//预览装车图片
export const getLoadCarInfoReviewImages = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetLoadCarInfoReviewImages`, { params: params });
};

//下载装车图片
export const getLoadCarInfoReviewImagesFileOut = `${BaseApiUrl}/LoadCarInfo/GetLoadCarInfoReviewImagesFileOut`;

//删除装车单
export const deleteLoadCarInfo = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/DeleteLoadCarInfo`, { params: params });
};
//打印装车单查询
export const getLoadCarInfoPrint = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetLoadCarInfoPrint`, { params: params });
};

//回滚装车单
export const rollBackLoadCar = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/RollBackLoadCar`, { params: params });
};

//打印装车单
export const loadCarInfoStatusPrint = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/LoadCarInfoStatusPrint`, { params: params });
};
//判断备货任务状态
export const judgePlanRelationStatus = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/JudgePlanRelationStatus`, { params: params });
};

//备货任务页面跳转查询计划（默认勾选加载全部计划）
export const getSholeStockingBoxSum = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/GetSholeStockingBoxSum`, { params: params });
};

//装车单修改判断是否异常
export const judgeLoadCarInfoIsAbnormal = params => {
    return axios.get(`${BaseApiUrl}/LoadCarInfo/JudgeLoadCarInfoIsAbnormal`, { params: params });
};

///获取装车司机信息
export function GetPutCarDriverInfo(params) {
    return axios.get(`${BaseApiUrl}/PutOnCar/GetPutCarDriverInfo`, { params: params }).then(res => res.data);
 }

 // 装车司机信息保存
export const SaveMakeUpLogisticsInfo = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/SaveMakeUpLogisticsInfo`, { ...params }).then(res => res.data);
}


